import { BaseModel } from '@/models/base/BaseModel';
import { MaintenanceForm } from '@/models/maintenance/MaintenanceForm';
import { MaintenanceChecklist } from '@/models/maintenance/MaintenanceChecklist';
import { MaintenanceMedia } from '@/models/maintenance/MaintenanceMedia';
import { MaintenanceMonthlyRepeat } from '@/models/maintenance/MaintenanceMonthlyRepeat';
import { RecurringRepeatOnDay, RecurringRepeatOnNumber, RecurringRepeatType } from '@/enums/RecurringEventsType';
import moment from 'moment';

export class MaintenanceScheduledRequest extends BaseModel{
  DateTime: Date;
  dateTime: Date;
  category: string;
  categoryId: string;
  icon: string;
  location: string;
  locationId?: string;
  vendor?: string;
  vendorId?: string;
  vendorEmail?: string;
  assignee?: string;
  assigneeId?: string;
  assigneeEmail?: string;
  assigneePhoneNumber?: string;
  cadence?: string;
  wing?: string;
  wingId?: string;
  department?: string;
  description?: string;
  comment?: string;
  priority?: string;
  isSendEmailToVendor?: boolean;
  typeId?: string;
  createdByStaffId?: string;
  createdByStaffName?: string;
  isHazardous: boolean;
  hazardousDetails: string;
  risk: string;
  riskDetails: string;
  maintenanceType: string;
  forms: MaintenanceForm[];
  checklist: MaintenanceChecklist[];
  media: MaintenanceMedia[];

  startDate: string;
  endDate: string;
  noEndDate: boolean;
  recurringRepetitions: number;
  recurringRepeatType: string;
  recurringRepetitionsDays: [];
  monthlyRepeatOn: MaintenanceMonthlyRepeat[];

  constructor() {
    super();
    this.dateTime = null;
    this.category = "";
    this.categoryId = "";
    this.icon = "";
    this.location = "";
    this.locationId = "";
    this.vendor = "";
    this.vendorId = "";
    this.vendorEmail = "";
    this.assignee = "";
    this.assigneeId = "";
    this.assigneeEmail = "";
    this.assigneePhoneNumber = "";
    this.cadence = "";
    this.wing = "";
    this.wingId = "";
    this.department = "";
    this.description = "";
    this.comment = "";
    this.priority = "";
    this.isSendEmailToVendor = false;
    this.typeId = "";
    this.createdByStaffId = "";
    this.createdByStaffName = "";
    this.isHazardous = false;
    this.hazardousDetails = "";
    this.risk = "";
    this.riskDetails = "";
    this.maintenanceType = "";
    this.forms = [];
    this.checklist = [];
    this.media = [];

    this.startDate = moment().format("YYYY-MM-DD");
    this.endDate =  moment().add('month', 1).format("YYYY-MM-DD");
    this.noEndDate = false;
    this.recurringRepetitions = 1;
    this.recurringRepeatType = RecurringRepeatType.Day;
    this.recurringRepetitionsDays = [];
    this.monthlyRepeatOn = [{
      position: RecurringRepeatOnNumber.First,
      day: RecurringRepeatOnDay.Monday
    }];
  }
}